import axiosInstance from "../../../utils/axios";

const BASE = "ebs-snapshots";

// ─── Snapshots ────────────────────────────────────────────────────────────────

export const listSnapshots = async (desktopRef) => {
  const params = desktopRef ? { desktop: desktopRef } : {};
  const response = await axiosInstance.get(BASE, { params });
  return response.data;
};

export const getSnapshot = async (name) => {
  const response = await axiosInstance.get(`${BASE}/${name}`);
  return response.data;
};

export const createSnapshot = async (payload) => {
  const response = await axiosInstance.post(BASE, payload);
  return response.data;
};

export const deleteSnapshot = async (name) => {
  await axiosInstance.delete(`${BASE}/${name}`);
};

// ─── Policies ─────────────────────────────────────────────────────────────────

export const listPolicies = async (desktopRef) => {
  const params = desktopRef ? { desktop: desktopRef } : {};
  const response = await axiosInstance.get(`${BASE}/policies`, { params });
  return response.data;
};

export const createPolicy = async (payload) => {
  const response = await axiosInstance.post(`${BASE}/policies`, payload);
  return response.data;
};

export const patchPolicy = async (name, patch) => {
  const response = await axiosInstance.patch(`${BASE}/policies/${name}`, patch);
  return response.data;
};

export const deletePolicy = async (name) => {
  await axiosInstance.delete(`${BASE}/policies/${name}`);
};

const ebsSnapshotApi = {
  listSnapshots,
  getSnapshot,
  createSnapshot,
  deleteSnapshot,
  listPolicies,
  createPolicy,
  patchPolicy,
  deletePolicy
};

export default ebsSnapshotApi;
